export default __webpack_public_path__ + "static/media/Opposites03_02.d2d66f8f.png";